// tslint:disable
import { Injectable } from '@angular/core';

import { DwItem, DwItemDetail, DwQuery, DwOrmData } from '@devwareapps/devware-cap';
import * as EnterpriseMetaData from '@devwareapps/devware-cap';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/************************************************
   Generated with the Devware CAP CLI 4.4.44
   Code Gen Name   EquipRental
   API Url         https://wappsdev.wachter.com/DevwareCapApi/

   Generated By    MSI/mlt
   Generate On     9/30/2024 4:41:35 PM
************************************************/

export enum EquipRentalMetaDataItemNames {
    CodeValue = 'CodeValue',
    Company = 'Company',
    Equipment = 'Equipment',
    EquipmentCompany = 'EquipmentCompany',
    EthosCodeValue = 'Ethos_CodeValue',
    EthosCodeValueCustom = 'Ethos_CodeValueCustom',
    EthosWachterCompany = 'Ethos_WachterCompany',
    Request = 'Request',
    RequestEquipment = 'RequestEquipment',
    RoRequestContext = 'roRequestContext',
    RoRequestContextJn = 'roRequestContextJn',
    RoRequestContextPo = 'roRequestContextPo',
    RoRequestContextWjid = 'roRequestContextWjid',
    Template = 'Template',
}

export enum EquipRentalMetaDataLookups {
    ActiveWachterCompanies = 2880,
    CodeValueAccessControl = 2811,
    CodeValueAccessControlAdditionalOptions = 1849,
    CodeValueCCTVTypesOfInstall = 1851,
    CodeValueCompanyLicenseStatus = 2877,
    CodeValueDifferentTypeOfElectrical = 1846,
    CodeValueElectricalNewWorkType = 1848,
    CodeValueEquipmentRequestJobContext = 2995,
    CodeValueFireAlarmDemoOrInstall = 1850,
    CodeValueFleetAuctionStatus = 2954,
    CodeValueFleetAuctionStatusActive = 2964,
    CodeValueFleetAuctionStatusCompleted = 2965,
    CodeValueFleetAuctionStatusNotStarted = 2963,
    CodeValueFleetDriveTrain = 2947,
    CodeValueFleetFuelType = 2948,
    CodeValueFleetOwnershipType = 2945,
    CodeValueFleetVehicleCondition = 2949,
    CodeValueFleetVehicleStatus = 2944,
    CodeValueFleetVehicleType = 2946,
    CodeValueInspectionState = 1866,
    CodeValueInspectionTimeOfDay = 1863,
    CodeValueLicenseStatus = 1467,
    CodeValueMORSubTypeByIssueType = 1513,
    CodeValuePassFail = 1867,
    CodeValuePerformWork = 1803,
    CodeValuePermitCableType = 1799,
    CodeValuePermitRequestAddAction = 2865,
    CodeValuePermitRequestElectricalOutletType = 1845,
    CodeValuePermitRequestType = 1798,
    CodeValuePermitStatus = 1801,
    CodeValueTypesOfElectrical = 1847,
    CodeValueVehicleAccidentFormVersion = 3000,
    CodeValueVehicleAccidentLineOfBusiness = 3001,
    CodeValueAccidentType = 1541,
    CodeValueAccidentTypeWorkplace = 1648,
    CodeValueAirportPlan = 1596,
    CodeValueAtFault = 1542,
    CodeValueBodyPart = 1684,
    CodeValueBodySide = 1685,
    CodeValueBusinessPlanReviewAccidentType = 1587,
    CodeValueClaimStatus = 1544,
    CodeValueEmployeeTrainingNeeded = 1525,
    CodeValueEmployeeTrainingNeededConclusion = 1532,
    CodeValueEmployeeTrainingNeededStatus = 1534,
    CodeValueEmsWorkStatus = 1638,
    CodeValueEquipmentDelivery = 1453,
    CodeValueEthosJobNumberType = 2868,
    CodeValueEthosSkill = 2840,
    CodeValueFiveStarRatingValue = 1616,
    CodeValueInjuryType = 1683,
    CodeValueInspectionResults = 1869,
    CodeValueInsuranceCompany = 1545,
    CodeValueJobType = 2821,
    CodeValueLodgingPlan = 1598,
    CodeValueMemoOfRecordIssueSubTypeAll = 1515,
    CodeValueMemoOfRecordConclusion = 1511,
    CodeValueMemoOfRecordEmployeeType = 1510,
    CodeValueMemoOfRecordIssueType = 1512,
    CodeValueMORStatus = 1517,
    CodeValuePayJobChangeDepartmentRole = 1485,
    CodeValuePayJobChangeStatus = 1481,
    CodeValuePayJobChangeType = 1486,
    CodeValuePermitTeam = 1731,
    CodeValuePermitType = 1726,
    CodeValuePlenumOrRiser = 1727,
    CodeValueTechType = 1586,
    CodeValueTermResignType = 1487,
    CodeValueTransportationPlan = 1597,
    CodeValueTravelMode = 1595,
    CodeValueTravelRequestStatus = 1601,
    CodeValueTravelType = 1599,
    CodeValueVechicleRepaired = 1543,
    CodeValueWorkerType = 1792,
    CodeValueWorkersCompClaimStatus = 2862,
    CodeValueWorksiteType = 1647,
    CompanyAllItems = 1358,
    EquipmentAllItems = 1360,
    EquipmentRequestContextByJobNumber = 2997,
    EquipmentRequestContextByPO = 2999,
    EquipmentRequestContextByWJID = 2998,
    EquipmentCompanyAllItems = 1359,
    EthosInvoiceDeliveryType = 1707,
    EthosUserTypeCodeValue = 1690,
    EthosCodeValueAllItems = 1631,
    EthosCodeValueCustomAllItems = 1733,
    FleetAuctionStatusWorkflow = 2979,
    PermitJobTypeLookup = 1811,
    PermitRequestJobTypeLookupNoJobNumber = 1873,
    Permitv2JobTypeLookupNoJobNumber = 2845,
    PlenumRiseOutdoor = 1796,
    ProjectKickoffBillingFrequency = 2923,
    ProjectKickoffBillingType = 2922,
    RequestAllItems = 1356,
    RequestEquipmentAllItems = 1361,
    RoRequestContextAllItems = 2996,
    RoRequestContextJnAllItems = 3002,
    RoRequestContextPoAllItems = 3003,
    RoRequestContextWjidAllItems = 3004,
    TemplateActiveItems = 1357,
    TrustCodeValueAllItems = 1388,
}

@Injectable({
    providedIn: 'root'
})
export class EquipRentalMetaDataService {

    CodeValue : CodeValueMetaData = new CodeValueMetaData();
    Company : CompanyMetaData = new CompanyMetaData();
    Equipment : EquipmentMetaData = new EquipmentMetaData();
    EquipmentCompany : EquipmentCompanyMetaData = new EquipmentCompanyMetaData();
    EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    EthosWachterCompany : EthosWachterCompanyMetaData = new EthosWachterCompanyMetaData();
    Request : RequestMetaData = new RequestMetaData();
    RequestEquipment : RequestEquipmentMetaData = new RequestEquipmentMetaData();
    RoRequestContext : RoRequestContextMetaData = new RoRequestContextMetaData();
    RoRequestContextJn : RoRequestContextJnMetaData = new RoRequestContextJnMetaData();
    RoRequestContextPo : RoRequestContextPoMetaData = new RoRequestContextPoMetaData();
    RoRequestContextWjid : RoRequestContextWjidMetaData = new RoRequestContextWjidMetaData();
    Template : TemplateMetaData = new TemplateMetaData();
}

// Generated Classes for MetaData service
export class CodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2385;
        this.ItemDetail.ItemName='CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Request - Delivery Option Cv - Many */
            RequestByDeliveryOptionCv : {
                RelationName: 'CodeValue|Request|DeliveryOptionCv',
                FieldPrefix: 'DeliveryOptionCvRequest',
                PropertyName: 'DeliveryOptionCvRequest'
            },
    };
}

export class CompanyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Company.';

    constructor() {
        this.ItemDetail.ItemId=2355;
        this.ItemDetail.ItemName='Company';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CompanyId : string = this.i + 'CompanyId';
    Company : string = this.i + 'Company';
    AcctNumber : string = this.i + 'AcctNumber';
    Email : string = this.i + 'Email';
    CompanyOrder : string = this.i + 'CompanyOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
            /** Relation: Request */
            Request : {
                RelationName: 'Company|Request|CompanyId',
                FieldPrefix: 'Request',
                PropertyName: 'Request'
            },
    };
}

export class EquipmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Equipment.';

    constructor() {
        this.ItemDetail.ItemId=2357;
        this.ItemDetail.ItemName='Equipment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EquipmentId : string = this.i + 'EquipmentId';
    Description : string = this.i + 'Description';

    Relations = {
            /** Relation: Request Equipment */
            RequestEquipment : {
                RelationName: 'Equipment|RequestEquipment|EquipmentId',
                FieldPrefix: 'RequestEquipment',
                PropertyName: 'RequestEquipment'
            },
    };
}

export class EquipmentCompanyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'EquipmentCompany.';

    constructor() {
        this.ItemDetail.ItemId=2356;
        this.ItemDetail.ItemName='EquipmentCompany';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    EquipmentCompanyId : string = this.i + 'EquipmentCompanyId';
    CompanyId : string = this.i + 'CompanyId';
    EquipmentId : string = this.i + 'EquipmentId';
    DayPrice : string = this.i + 'Day Price';
    WeekPrice : string = this.i + 'Week Price';
    MonthPrice : string = this.i + 'Month Price';

    Relations = {
    };
}

export class EthosCodeValueMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValue.';

    constructor() {
        this.ItemDetail.ItemId=2579;
        this.ItemDetail.ItemName='Ethos_CodeValue';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';
    ImagePath : string = this.i + 'ImagePath';

    Relations = {
    };
}

export class EthosCodeValueCustomMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_CodeValueCustom.';

    constructor() {
        this.ItemDetail.ItemId=2643;
        this.ItemDetail.ItemName='Ethos_CodeValueCustom';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueCustomId : string = this.i + 'CodeValueCustomId';
    CodeSetId : string = this.i + 'CodeSetId';
    Display : string = this.i + 'Display';
    Meaning : string = this.i + 'Meaning';
    Description : string = this.i + 'Description';
    CodeValueOrder : string = this.i + 'CodeValueOrder';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class EthosWachterCompanyMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Ethos_WachterCompany.';

    constructor() {
        this.ItemDetail.ItemId=2804;
        this.ItemDetail.ItemName='Ethos_WachterCompany';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    WachterCompanyId : string = this.i + 'WachterCompanyId';
    WachterCompanyName : string = this.i + 'WachterCompanyName';
    WachterCompanyShortName : string = this.i + 'WachterCompanyShortName';
    PresidentUserId : string = this.i + 'PresidentUserId';
    VicePresidentUserId : string = this.i + 'VicePresidentUserId';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    CreatedBy : string = this.i + 'CreatedBy';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    ModifiedBy : string = this.i + 'ModifiedBy';
    AxIntegrationId : string = this.i + 'AxIntegrationId';
    IsActive : string = this.i + 'IsActive';

    Relations = {
    };
}

export class RequestMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Request.';

    constructor() {
        this.ItemDetail.ItemId=2353;
        this.ItemDetail.ItemName='Request';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequestId : string = this.i + 'RequestId';
    CompanyId : string = this.i + 'CompanyId';
    DeliveryOptionCv : string = this.i + 'DeliveryOptionCv';
    CompanyEmail : string = this.i + 'CompanyEmail';
    EmailCopyString : string = this.i + 'EmailCopyString';
    AcountNumber : string = this.i + 'AcountNumber';
    NeededByDateTime : string = this.i + 'NeededByDateTime';
    DeliveredByDateTime : string = this.i + 'DeliveredByDateTime';
    PickupByDateTime : string = this.i + 'PickupByDateTime';
    IsAutoPickup : string = this.i + 'IsAutoPickup';
    AreSubstitutionsAllowed : string = this.i + 'AreSubstitutionsAllowed';
    HasProtectionPlan : string = this.i + 'HasProtectionPlan';
    Notes : string = this.i + 'Notes';
    JobNumber : string = this.i + 'JobNumber';
    JobSiteAddress : string = this.i + 'JobSiteAddress';
    SiteContactName : string = this.i + 'SiteContactName';
    SiteContactPhoneNumber : string = this.i + 'SiteContactPhoneNumber';
    DropOffArea : string = this.i + 'DropOffArea';
    RequesterNameAndNumber : string = this.i + 'RequesterNameAndNumber';
    CreatedByEthosUserId : string = this.i + 'CreatedByEthos_UserId';
    CreatedByDateTime : string = this.i + 'CreatedByDateTime';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';
    ModifiedByDateTime : string = this.i + 'ModifiedByDateTime';
    IsDeleted : string = this.i + 'IsDeleted';
    AutoPickupText : string = this.i + 'AutoPickupText';
    JobName : string = this.i + 'JobName';
    LookUpTarget : string = this.i + 'LookUpTarget';
    Phase : string = this.i + 'Phase';

    Relations = {
            /** Relation: Trust Code Value - Delivery Option */
            CodeValueByDeliveryOptionCv : {
                RelationName: 'CodeValue|Request|DeliveryOptionCv',
                FieldPrefix: 'DeliveryOptionCvCodeValue',
                PropertyName: 'DeliveryOptionCvCodeValue'
            },
            /** Relation: Company */
            Company : {
                RelationName: 'Company|Request|CompanyId',
                FieldPrefix: 'Company',
                PropertyName: 'Company'
            },
            /** Relation: Request Equipment */
            RequestEquipment : {
                RelationName: 'Request|RequestEquipment|RequestId',
                FieldPrefix: 'RequestEquipment',
                PropertyName: 'RequestEquipment'
            },
    };
}

export class RequestEquipmentMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'RequestEquipment.';

    constructor() {
        this.ItemDetail.ItemId=2358;
        this.ItemDetail.ItemName='RequestEquipment';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    RequestEquipmentId : string = this.i + 'RequestEquipmentId';
    RequestId : string = this.i + 'RequestId';
    EquipmentId : string = this.i + 'EquipmentId';
    Quantity : string = this.i + 'Quantity';
    Comments : string = this.i + 'Comments';
    EquipmentText : string = this.i + 'EquipmentText';

    Relations = {
            /** Relation: Equipment */
            Equipment : {
                RelationName: 'Equipment|RequestEquipment|EquipmentId',
                FieldPrefix: 'Equipment',
                PropertyName: 'Equipment'
            },
            /** Relation: Request */
            Request : {
                RelationName: 'Request|RequestEquipment|RequestId',
                FieldPrefix: 'Request',
                PropertyName: 'Request'
            },
    };
}

export class RoRequestContextMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roRequestContext.';

    constructor() {
        this.ItemDetail.ItemId=3453;
        this.ItemDetail.ItemName='roRequestContext';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    CodeValueId : string = this.i + 'CodeValueId';
    Target : string = this.i + 'Target';
    JobNumber : string = this.i + 'JobNumber';
    JobName : string = this.i + 'JobName';
    WJID : string = this.i + 'WJID';
    TargetId : string = this.i + 'TargetId';

    Relations = {
    };
}

export class RoRequestContextJnMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roRequestContextJn.';

    constructor() {
        this.ItemDetail.ItemId=3454;
        this.ItemDetail.ItemName='roRequestContextJn';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TargetId : string = this.i + 'TargetId';
    CodeValueId : string = this.i + 'CodeValueId';
    Target : string = this.i + 'Target';
    JobNumber : string = this.i + 'JobNumber';
    JobName : string = this.i + 'JobName';
    WJID : string = this.i + 'WJID';
    OH : string = this.i + 'OH';

    Relations = {
    };
}

export class RoRequestContextPoMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roRequestContextPo.';

    constructor() {
        this.ItemDetail.ItemId=3455;
        this.ItemDetail.ItemName='roRequestContextPo';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TargetId : string = this.i + 'TargetId';
    CodeValueId : string = this.i + 'CodeValueId';
    Target : string = this.i + 'Target';
    JobNumber : string = this.i + 'JobNumber';
    JobName : string = this.i + 'JobName';
    WJID : string = this.i + 'WJID';
    Address : string = this.i + 'Address';

    Relations = {
    };
}

export class RoRequestContextWjidMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'roRequestContextWjid.';

    constructor() {
        this.ItemDetail.ItemId=3456;
        this.ItemDetail.ItemName='roRequestContextWjid';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TargetId : string = this.i + 'TargetId';
    CodeValueId : string = this.i + 'CodeValueId';
    Target : string = this.i + 'Target';
    JobNumber : string = this.i + 'JobNumber';
    JobName : string = this.i + 'JobName';
    WJID : string = this.i + 'WJID';
    Address : string = this.i + 'Address';

    Relations = {
    };
}

export class TemplateMetaData implements DwItem {
    ItemDetail: DwItemDetail = new DwItemDetail();

    //shortcut to item name - to reduce file size
    private i : string = 'Template.';

    constructor() {
        this.ItemDetail.ItemId=2354;
        this.ItemDetail.ItemName='Template';
    }

    CreateQuery(): DwQuery {
            return new DwQuery(this.ItemDetail.ItemName);
    }


    // Attributes
    TemplateId : string = this.i + 'TemplateId';
    Name : string = this.i + 'Name';
    SettingsJson : string = this.i + 'SettingsJson';
    IsDeleted : string = this.i + 'IsDeleted';
    CreatedDateTime : string = this.i + 'CreatedDateTime';
    ModifiedDateTime : string = this.i + 'ModifiedDateTime';
    CreatedbyEthosUserId : string = this.i + 'CreatedbyEthos_UserId';
    ModifiedByEthosUserId : string = this.i + 'ModifiedByEthos_UserId';

    Relations = {
    };
}

export class EquipRentalMetaData {

    static CodeValue : CodeValueMetaData = new CodeValueMetaData();
    static Company : CompanyMetaData = new CompanyMetaData();
    static Equipment : EquipmentMetaData = new EquipmentMetaData();
    static EquipmentCompany : EquipmentCompanyMetaData = new EquipmentCompanyMetaData();
    static EthosCodeValue : EthosCodeValueMetaData = new EthosCodeValueMetaData();
    static EthosCodeValueCustom : EthosCodeValueCustomMetaData = new EthosCodeValueCustomMetaData();
    static EthosWachterCompany : EthosWachterCompanyMetaData = new EthosWachterCompanyMetaData();
    static Request : RequestMetaData = new RequestMetaData();
    static RequestEquipment : RequestEquipmentMetaData = new RequestEquipmentMetaData();
    static RoRequestContext : RoRequestContextMetaData = new RoRequestContextMetaData();
    static RoRequestContextJn : RoRequestContextJnMetaData = new RoRequestContextJnMetaData();
    static RoRequestContextPo : RoRequestContextPoMetaData = new RoRequestContextPoMetaData();
    static RoRequestContextWjid : RoRequestContextWjidMetaData = new RoRequestContextWjidMetaData();
    static Template : TemplateMetaData = new TemplateMetaData();
}
// Generated Entity Interfaces
export interface CodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
    DeliveryOptionCvRequest? : RequestEntity[];
}

export interface CompanyEntity extends DwOrmData {
    // Attributes
    CompanyId?: number;
    Company?: string;
    AcctNumber?: string;
    Email?: string;
    CompanyOrder?: number;
    IsActive?: boolean;


    // Relations
    Request? : RequestEntity[];
}

export interface EquipmentEntity extends DwOrmData {
    // Attributes
    EquipmentId?: number;
    Description?: string;


    // Relations
    RequestEquipment? : RequestEquipmentEntity[];
}

export interface EquipmentCompanyEntity extends DwOrmData {
    // Attributes
    EquipmentCompanyId?: number;
    CompanyId?: number;
    EquipmentId?: number;
    // Attribute Day Price has invalid characters and can't be included
    // Attribute Week Price has invalid characters and can't be included
    // Attribute Month Price has invalid characters and can't be included


    // Relations
}

export interface EthosCodeValueEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;
    ImagePath?: string;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
}

export interface EthosCodeValueCustomEntity extends DwOrmData {
    // Attributes
    CodeValueCustomId?: number;
    CodeSetId?: number;
    Display?: string;
    Meaning?: string;
    Description?: string;
    CodeValueOrder?: number;
    IsActive?: boolean;

    // Display Attributes
    CodeSetIdDisplay?: string;

    // Relations
}

export interface EthosWachterCompanyEntity extends DwOrmData {
    // Attributes
    WachterCompanyId?: number;
    WachterCompanyName?: string;
    WachterCompanyShortName?: string;
    PresidentUserId?: number;
    VicePresidentUserId?: number;
    CreatedDateTime?: string;
    CreatedBy?: number;
    ModifiedDateTime?: string;
    ModifiedBy?: number;
    AxIntegrationId?: string;
    IsActive?: boolean;


    // Relations
}

export interface RequestEntity extends DwOrmData {
    // Attributes
    RequestId?: number;
    CompanyId?: number;
    DeliveryOptionCv?: number;
    CompanyEmail?: string;
    EmailCopyString?: string;
    AcountNumber?: string;
    NeededByDateTime?: string;
    DeliveredByDateTime?: string;
    PickupByDateTime?: string;
    IsAutoPickup?: boolean;
    AreSubstitutionsAllowed?: boolean;
    HasProtectionPlan?: boolean;
    Notes?: string;
    JobNumber?: string;
    JobSiteAddress?: string;
    SiteContactName?: string;
    SiteContactPhoneNumber?: string;
    DropOffArea?: string;
    RequesterNameAndNumber?: string;
    CreatedByEthos_UserId?: number;
    CreatedByDateTime?: string;
    ModifiedByEthos_UserId?: number;
    ModifiedByDateTime?: string;
    IsDeleted?: boolean;
    AutoPickupText?: string;
    JobName?: string;
    LookUpTarget?: string;
    Phase?: string;

    // Display Attributes
    CompanyIdDisplay?: string;
    DeliveryOptionCvDisplay?: string;
    CreatedByEthos_UserIdDisplay?: string;
    ModifiedByEthos_UserIdDisplay?: string;

    // Relations
    DeliveryOptionCvCodeValue? : CodeValueEntity;
    Company? : CompanyEntity;
    RequestEquipment? : RequestEquipmentEntity[];
}

export interface RequestEquipmentEntity extends DwOrmData {
    // Attributes
    RequestEquipmentId?: number;
    RequestId?: number;
    EquipmentId?: number;
    Quantity?: number;
    Comments?: string;
    EquipmentText?: string;

    // Display Attributes
    RequestIdDisplay?: string;
    EquipmentIdDisplay?: string;

    // Relations
    Equipment? : EquipmentEntity;
    Request? : RequestEntity;
}

export interface RoRequestContextEntity extends DwOrmData {
    // Attributes
    CodeValueId?: number;
    Target?: string;
    JobNumber?: string;
    JobName?: string;
    WJID?: number;
    TargetId?: number;

    // Display Attributes
    CodeValueIdDisplay?: string;

    // Relations
}

export interface RoRequestContextJnEntity extends DwOrmData {
    // Attributes
    TargetId?: number;
    CodeValueId?: number;
    Target?: string;
    JobNumber?: string;
    JobName?: string;
    WJID?: number;
    OH?: boolean;


    // Relations
}

export interface RoRequestContextPoEntity extends DwOrmData {
    // Attributes
    TargetId?: number;
    CodeValueId?: number;
    Target?: string;
    JobNumber?: string;
    JobName?: string;
    WJID?: number;
    Address?: string;


    // Relations
}

export interface RoRequestContextWjidEntity extends DwOrmData {
    // Attributes
    TargetId?: number;
    CodeValueId?: number;
    Target?: string;
    JobNumber?: number;
    JobName?: string;
    WJID?: number;
    Address?: string;


    // Relations
}

export interface TemplateEntity extends DwOrmData {
    // Attributes
    TemplateId?: number;
    Name?: string;
    SettingsJson?: string;
    IsDeleted?: boolean;
    CreatedDateTime?: string;
    ModifiedDateTime?: string;
    CreatedbyEthos_UserId?: number;
    ModifiedByEthos_UserId?: number;


    // Relations
}

    // Lookup Value Enums  {
export enum CodeValueEquipmentRequestJobContext {
        JobNumber = 103941,
        WJID = 103942,
        PONumber = 103943,
    }




